import React, { Component } from 'react';
//import { BrowserRouter as Router, Route } from "react-router-dom";
import './assets/css/App.css';
/*import Home from "./components/home";*/
import SizeSelectorApp from './components/size_selector';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="App-logo" />
        </header>
        <SizeSelectorApp />
      </div>
    );
  }
}

export default App;
/*
        <Router>
          <div>
            <Route exact path="/" component={} />
            <Route path="/size-selector" component={SizeSelectorApp} />
          </div>
        </Router>
        */
